import { render } from "./tenant-delete.vue?vue&type=template&id=76d45669"
import script from "./tenant-delete.vue?vue&type=script&lang=js"
export * from "./tenant-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__